import { useContext } from "react";
import { useMatches, useParams } from "react-router-dom";
import { AbilityContext } from "../context/Can";
import { RouteCan, RouteCanAny } from "../routeCan";

type Handle = { can: RouteCan | RouteCanAny };

export const useRouteCans = () => {
    const matches = useMatches();
    const params = useParams();

    const routeCans = matches.map((match) => (match.handle as Handle)?.can).filter(Boolean);
    const ability = useContext(AbilityContext);

    const passes = (routeCan: RouteCan | RouteCanAny): boolean =>
        "any" in routeCan
            ? routeCan.any.some(passes)
            : ability.can(routeCan.i, typeof routeCan.a === "function" ? routeCan.a(params) : routeCan.a);

    const hasPermission = routeCans.length === 0 || routeCans.every(passes);

    return { hasPermission };
};
